







































































import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/commonComponents/header/header.vue";
import PagePreview from "./pagePreview/pagePreview.vue";
import TopController from "./topController/topController.vue";
import RightController from "./rightController/rightController.vue";
import PageController from '@/commonComponents/pageController/pageController.vue';
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";
import PrintLoading from "./printLoading/printLoading.vue"
import PrintConfirmation from "./printConfirmation/printConfirmation.vue";
import PrintRotaionAlert from "@/commonComponents/alertModal/printRotationAlert/printRotationAlert.vue";
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import DocumentPage from "@/containers/document-page/DocumentPage.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import FontConvertModal from "@/commonComponents/alertModal/fontConvertModal/fontConvertModal.vue";
import DiscardConfirmation from "@/commonComponents/alertModal/discardConfirmationModal/discardConfirmationModal.vue";
import SaveAttentionAlert from "@/commonComponents/alertModal/saveAttentionAlert/saveAttentionAlert.vue";
import StandByScreen from "@/commonComponents/standByScreen/standByScreen.vue";
import AskConvert3dTextAlertModal from "@/commonComponents/alertModal/askConvert3dTextAlertModal/askConvert3dTextAlertModal.vue";

import * as def from "@/definitions";
import { Const } from '@/const';
// TODO document2
import { Document } from "@/model/document2/document";
import { Page } from "@/model/document2/page/page";
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from '@/model/document2/page/surface/design/layer/layer'
import { UserConfig } from '@/model/userConfig/userConfig';
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { Rectangle } from '@/utilityModels/rectangle';

// Helper
import { FileHelper } from "@/helper/fileHelper";
import { LogHelper } from "@/helper/logHelper";
import { RequestHelper } from '@/helper/requestHelper';
import { InsertionHelper } from '@/helper/insertionHelper';
import { NameHelper } from "@/helper/nameHelper"
import { UserAgentHelper } from "@/helper/userAgentHelper"
import { ResourceHelper } from "@/helper/resourceHelper"
import { DocumentHelper } from '@/helper/documentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { UnitHelper } from "@/helper/unitHelper";
import { mm2px } from '@/helper/unitHelper';
import { NativeHelper } from "@/helper/nativeHelper";
import { StringHelper } from "@/helper/stringHelper";
import { ImageHelper } from "@/helper/imageHelper";

import { FileConverter } from '@/label_convert/fileConverter';

import { ShortcutManager } from '@/model/shortcutManager/shortcutManager';

import { CloudAccount } from "@/cloudAccount/cloudAccount";
import { FontManager } from '@/model/fontManager/fontManager';

import printJS from 'print-js';
import jsPDF from "jspdf";

@Component({
  components: {
    Header,
    PagePreview,
    DocumentPage,
    TopController,
    RightController,
    PageController,
    ColorPicker,
    PrintLoading,
    PrintConfirmation,
    PrintRotaionAlert,
    Tutorial,
    License,
    LoadingScreen,

    FontConvertModal,
    DiscardConfirmation,

    SaveAttentionAlert,
    StandByScreen,
    AskConvert3dTextAlertModal
  }
})

// 印刷設定
export default class PrintSetting extends Vue
{
    // 差し込み用ページ
    private insertionPage : Page | null = null;
    private insertionMaxPage : number = 0;
    private updatePage()
    {
        this.insertionPage = null;
        this.insertionPage = InsertionHelper.createPage(this.currentDocument, this.currentDocument.currentPageIndex);
    }
    private updateMaxPage()
    {
        this.insertionMaxPage = InsertionHelper.calcPageCount(this.currentDocument);
    }
    private disposePage()
    {
        this.insertionPage = null;
    }

    // サーバーを通さずにプリントするかどうか
    private get printsOnLocal(): boolean
    {
        return UserAgentHelper.isElectron() || UserAgentHelper.getBrowser() === 'chrome';
    }
    // Electronかどうか
    private get isElectron() : boolean
    {
        return UserAgentHelper.isElectron();
    }

    // プリントレコメンド
    // 印刷コンテンツ作成中
    private isCreatingPrintContent = false;
    // レコメンドタイマー起動中
    private isRunningPrintLoadingTimer = false;
    private get loading()
    {
        if (process.env.VUE_APP_ADVERTISEMENT_BEFORE_PRINT === 'yes') {
            return this.isCreatingPrintContent || this.isRunningPrintLoadingTimer;
        } else {
            return this.isCreatingPrintContent;
        }
    }

    private get currentTab() { return "/PrintSetting"; }

    private get paperInfoText() { return DocumentHelper.getPaperInfoText(this.currentDocument); }

    // ズーム
    private zoomScale: number = 100;
    private isAutoZoom: boolean = true;

    // チュートリアルフラグ
    isTutorial = false;
    // 使用規約許諾フラグ
    isLicense = false;

    // 待機
    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    // 印刷待機
    private printWaitNumber = -1;
    private static readonly PRINT_WAIT_POLLING_TIME = 1000;

    // ショートカットキー、およびメニューのID
    static readonly MENU_COMMAND_ZOOM_100 = "print_setting_zoom_100";
    static readonly MENU_COMMAND_ZOOM_IN = "print_setting_zoom_in";

    // ヘッダーで画面から抜ける時の処理
    private onHeaderNavigationStart(link : string)
    {
        if(link == "/DesignEditor" || link == "/LayoutEditor")
        {
            // デザイン、レイアウトに遷移する時に処理中表示
            this.isWaiting = true;
        }
    }

    private onHeaderNavigationFinish(link : string)
    {
        // 処理中を非表示
        this.isWaiting = false;
    }

    // 遷移処理
    // showWait : 待機モーダルを表示する
    private goLink(link : string, showWait : boolean = false)
    {
        if(showWait)
        {
            this.isWaiting = true;
            setTimeout(() =>
            {
                this.isWaiting = false;
                this.$router.push(link);
            }, 50);
        }
        else
        {
            this.$router.push(link);
        }
    }

    private mounted(){
        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("printSettingTutorial") != true){
            this.isTutorial = true;
        }

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        // ショートカット登録
        this.registerShortcut();
        document.addEventListener("keydown", this.onKeyDown);

        if(this.currentDocument.useInsertion)
        {
            this.updatePage();
            this.updateMaxPage();
        }
        if(this.printsOnLocal)
        {
            this.updatePageListForPrint();
        }

        this.printEndPage = this.maxPage;
    }

    private destroyed()
    {
        // ショートカット解除
        this.unregisterShortcut();
        document.removeEventListener("keydown", this.onKeyDown);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        if(this.currentDocument.useInsertion)
        {
            this.disposePage();
            if(this.printsOnLocal)
            {
                this.disposePageListForPrint();
            }
        }
    }

    private registerShortcut()
    {
        // ショートカット登録
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        if(UserAgentHelper.isElectron())
        {
            // DL版のみ
            manager.addKeyboardShortcut(PrintSetting.MENU_COMMAND_ZOOM_100, "ctrl", "1", () => this.executeCommand(PrintSetting.MENU_COMMAND_ZOOM_100), () => this.canExecuteCommand(PrintSetting.MENU_COMMAND_ZOOM_100));
            manager.addKeyboardShortcut(PrintSetting.MENU_COMMAND_ZOOM_IN, "ctrl + shift", "-", () => this.executeCommand(PrintSetting.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(PrintSetting.MENU_COMMAND_ZOOM_IN));
            manager.addKeyboardShortcut(PrintSetting.MENU_COMMAND_ZOOM_IN, "ctrl + shift", "=", () => this.executeCommand(PrintSetting.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(PrintSetting.MENU_COMMAND_ZOOM_IN));
        }
    }

    private unregisterShortcut()
    {
        // ショートカット解除
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        if(UserAgentHelper.isElectron())
        {
            // DL版のみ
            manager.removeKeyboardShortcut(PrintSetting.MENU_COMMAND_ZOOM_100);
            manager.removeKeyboardShortcut(PrintSetting.MENU_COMMAND_ZOOM_IN);
        }
    }

    // メニューコマンド処理
    private canExecuteCommand(key) : boolean
    {
        var canExecute = false;
        if(key == PrintSetting.MENU_COMMAND_ZOOM_100)
        {
            canExecute = true;
        }
        else if(key == PrintSetting.MENU_COMMAND_ZOOM_IN)
        {
            canExecute = this.changeZoomScaleByStep(true, true, false);
        }

        return canExecute;
    }

    private executeCommand(key) : void
    {
        if(key == PrintSetting.MENU_COMMAND_ZOOM_100)
        {
            this.changeZoomScale(100, true);
        }
        else if(key == PrintSetting.MENU_COMMAND_ZOOM_IN)
        {
            this.changeZoomScaleByStep(true, true, true);
        }
    }

    private onKeyDown(event)
    {
        // ショートカット実行
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.doKeyboardShortcutIfNeeded(event);
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(paramParent : any)
    {
        try
        {
            var command : string = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "new_document")
            {
                // 新規ドキュメント
                this.createNewDocument();
            }
            else if(command == "save_document_completed")
            {
                // ドキュメントの保存完了をネイティブから通知される
                if(this.isSaveModalVisible)
                {
                    // 保存モーダル表示中であれば、完了処理を行う
                    this.saveModalCompletion();
                }
                // ドキュメントのハッシュ更新
                this.currentDocument.updateHash();

                // 保存履歴送信
                LogHelper.sendLog("1000", {
                    productId : this.currentDocument.productId,
                    code : this.currentDocument.paperCode,
                    templateId : this.$store.getters.data.selectedTemplate.id,
                    cloud : 0
                });
            }
            else if(command == "import_document")
            {
                // ドキュメント読み込み
                let doc = FileHelper.loadDocumentAnyway(parameter.document);
                if(doc != null)
                {
                    let filePath = parameter.filePath;
                    let fileName = parameter.fileName != null ? parameter.fileName : "";

                    doc.currentFilePath = filePath;
                    doc.openedFileName = fileName;
                    let comp = () =>
                    {
                        // ドキュメントの準備
                        this.$store.getters.applicationState.preloadDocument = doc;
                        // 画面遷移
                        this.$router.push("/LayoutEditor");
                    };
                    // フォントコンバート対応
                    FontManager.applyUnloadedFontsToDocument(doc);
                    if(doc.unloadedFonts.length > 0)
                    {
                        // 利用できないフォントがあった場合
                        var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                        // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                        fontConvertModal.open(doc.unloadedFonts,
                        () =>
                        {
                            comp();
                        });
                    }
                    else
                    {
                        comp();
                    }
                }
            }
            else if(command == "import_label9_document")
            {
                // ラベル9ドキュメント読み込み
                let documentBuf = parameter.document;
                let filePath = parameter.filePath;

                // zip解凍
                let Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
                let uz = new Unzip(documentBuf);
                let filenames = uz.getFilenames();
                if(filenames && filenames.length > 0)
                {
                    // 最初のファイル(xml)
                    let decompressed = uz.decompress(filenames[0]);
                    let documentXml = StringHelper.utf8ArrayToStr(decompressed);
                    // ファイルコンバート
                    let fileConverter = new FileConverter(this.$store.getters.fontManager);
                    let doc = fileConverter.deserializeLabel9FromXml(documentXml);
                    if(doc != null)
                    {
                        doc.currentFilePath = filePath;

                        // 完了処理
                        let completion = () =>
                        {
                            if(doc == null) return;
                            let completion2 = () =>
                            {
                                if(doc == null) return;
                                // ドキュメントの準備
                                this.$store.getters.applicationState.preloadDocument = doc;
                                // 画面遷移
                                this.$router.push("/LayoutEditor");
                            }
                            // ラベル屋さん9の3D文字のコンバート対応
                            if(DocumentHelper.contains3dTextLayers(doc)) {
                                (this.$refs.askConvert3dTextAlertModal as AskConvert3dTextAlertModal).open(ret => {
                                    if(doc == null) return;
                                    if(ret) {
                                        DocumentHelper.convert3dTextLayersToSimpleTextLayers(doc);
                                    }
                                    completion2();
                                })
                            } else {
                                completion2();
                            }
                        };

                        if(doc.unloadedFonts.length > 0)
                        {
                            // 利用できないフォントがあった場合
                            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                            // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                            fontConvertModal.open(doc.unloadedFonts,
                            () =>
                            {
                                if(doc != null) { completion(); }
                            });
                        }
                        else
                        {
                            completion();
                        }
                    }
                }
            }
            else if(command == "open_paper_info")
            {
                // 用紙情報を開く
                NativeHelper.sendNativeEvent("open_external_link", { url : Const.PRODUCT_DETAIL_URL_BASE + this.currentDocument.productCode });
            }
            else if(command == "switch_auto_zoom")
            {
                // 自動ズーム切り替え
                this.switchAutoZoom();
            }
            else if(command == "change_zoom_scale_by_step")
            {
                // ズーム変更
                this.changeZoomScaleByStep(parameter.direction == "up", true);
            }
            else if(command == "save_to_cloud_document")
            {
                // クラウドへ保存
                this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
                this.$store.dispatch("setCloudMode", "save");
                var cloudAccount = this.$store.getters.cloudAccount as CloudAccount;
                if(cloudAccount.isSignIn)
                {
                    this.$router.push("/cloud");
                }
                else
                {
                    this.$store.dispatch("setSignInToGo", "cloud");
                    this.$router.push("/signIn");
                }
            }
            else if(command == "print_pdf_completed" || command == "save_pdf_completed" || command == "print_pdf_error")
            {
                // 処理中を終了する
                this.isCreatingPrintContent = false;
            }
            else if(command == "set_page_capture")
            {
                // ページの画像キャプチャがElectronから送られた
                let captureImage = parameter.image;
                if(this.isCreatingPrintContent && this.suspendedCreatePdfProcess != null)
                {
                    // Pdf作成処理の続きを行う。
                    this.suspendedCreatePdfProcess(captureImage);
                }

            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private get currentDocument(): Document
    {
        return this.$store.getters.document;
    }

    private get currentPage(): Page
    {
        if(this.currentDocument.useInsertion)
        {
            return this.insertionPage != null ? this.insertionPage : this.currentDocument.pageList[0];
        }
        else
        {
            return this.currentDocument.pageList[this.currentDocument.currentPageIndex];
        }
    }

    private getPage(pageIndex : number)
    {
        if(this.currentDocument.useInsertion)
        {
            return InsertionHelper.createPage(this.currentDocument, pageIndex);
        }
        else
        {
            return this.currentDocument.pageList[pageIndex];
        }
    }

    private get isReverseSurface()
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    public get currentPageNumber(): number
    {
        return this.currentDocument.currentPageIndex + 1;
    }

    private get userConfig() : UserConfig
    {
        return this.$store.getters.userConfig;
    }
    // 印刷部数
    private paperNumber: number = 1;
    // 開始ページ
    private printStartPage: number = 1;
    // 終了ページ
    private printEndPage: number = 1;
    // 印刷用ページリスト * ローカル印刷で使う
    private pageListForPrint : Array<Page> | null = null;
    private updatePageListForPrint()
    {
        this.pageListForPrint = null;
        if(this.currentDocument.useInsertion)
        {
            this.pageListForPrint = InsertionHelper.createPageList(this.currentDocument, true);
        }
        else
        {
            this.pageListForPrint = this.currentDocument.pageList;
        }
    }
    private disposePageListForPrint()
    {
        this.pageListForPrint = null;
    }
    // 印刷倍率(%)
    private get printRate() { return this.userConfig.printRate; }
    // 反転印刷
    private get isPrintFlip() { return this.userConfig.isPrintFlip; }
    // 枠あり印刷
    private get isBorderVisible() { return this.userConfig.isPrintBorder; }
    // 枠の色
    private static readonly UNSELECTED_BORDER_COLOR = new ColorConstruct(151, 151, 151);
    private borderColorRgb = this.$store.getters.userConfigColors.buttonColorRgb;
    private borderColor: ColorConstruct = new ColorConstruct( this.borderColorRgb.r, this.borderColorRgb.g, this.borderColorRgb.b );
    private get borderWidthPreview()
    {
        return this.isBorderVisible ? 2 : 1;
    }
    // 枠色ピッカー表示フラグ
    private isBorderColorPickerVisible = false;
    // 枠色ピッカーの場所
    private pickerLeft: number = 0;
    private pickerTop: number = 0;
    private get pickerStyle() {
        return {
            position: "absolute",
            left: this.pickerLeft + "px",
            top: this.pickerTop + "px",
            zIndex: 10
        };
    }
    private get bleedSize() { return this.$store.getters.userConfig.bleedSize; }
    private get documentRotate() { return this.currentDocument.rotate; }

    // 印刷ページ数
    private get printPageCount()
    {
        return this.printEndPage - this.printStartPage + 1;
    }

    // 空フレーム数のカウント
    // オブジェクトが存在していない場合は空フレームにカウントする
    private get blankFrameCount()
    {
        if(this.currentDocument.useInsertion)
        {
            return InsertionHelper.calcBlankFrames(this.currentDocument);
        }
        else
        {
            var count = 0;
            for(var pageIndex = this.printStartPage - 1; pageIndex <= this.printEndPage - 1; ++pageIndex)
            {
                var page : Page | null = this.getPage(pageIndex);
                for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
                {
                    var design = page.getSurface(this.isReverseSurface).getDesign(designIndex);
                    if(design == null || !design.hasAnyObject())
                    {
                        count++;
                    }
                }
                page = null;
            }
            return count;
        }
    }

    // すべてのドキュメントへの編集は、このクラスから行う
    // action - mutation モデルへの移行も視野に入れている

    // コマンドのコール
    private onDoCommand(command: string, parameter: any)
    {
        if (command == "savePDF")
        {
            this.savePDFCommand();
        }
        else if (command == "saveDocument")
        {
            // document保存
            this.saveDocument();
        }
        else if (command == "print")
        {
            let confimation = this.$refs.printConfirmation as PrintConfirmation;
            confimation.open(() =>
            {
                if(UserAgentHelper.getBrowser() === "ie" || UserAgentHelper.getBrowser() === "edge" ||
                    UserAgentHelper.getBrowser() === "safari")
                {
                    // IE, Edge, SafariはPDF保存処理
                    this.savePDFCommand();
                }
                else
                {
                    // 印刷処理
                    if(this.$store.getters.userConfig.printRaster)
                    {
                        // ラスター印刷
                        this.printAsRaster(this.$store.getters.userConfig.getPrintDpi());
                    }
                    else
                    {
                        // ベクター印刷

                        if (this.printsOnLocal) 
                        {
                            // ブラウザの機能で印刷する
                            this.sendPrintLog();
                            this.localPrint();
                        }
                        else
                        {
                            // サーバでPDFを作成して印刷
                            this.serverPrint();
                        }
                    }
                }
            });
        }
        else if (command == "changeSurface")
        {
            // 面変更
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "printDoubleSides")
        {
            // 両面印刷
            this.printDoubleSides();
        }
        else if (command == "goPage")
        {
            // ページ変更
            this.goPage(parameter.page);
        }
        else if (command == "setPaperNumber")
        {
            // 印刷部数変更
            this.setPaperNumber(parameter.paperNumber);
        }
        else if (command == "setPrintStartPage")
        {
            // 開始ページ変更
            this.setPrintStartPage(parameter.page);
        }
        else if (command == "setPrintEndPage")
        {
            // 終了ページ変更
            this.setPrintEndPage(parameter.page);
        }
        else if (command == "setVerticalPosition")
        {
            // 位置調整 : 縦
            this.setVerticalPosition(parameter.position, parameter.isReverse);
        }
        else if (command == "setHorizontalPosition")
        {
            // 位置調整 : 横
            this.setHorizontalPosition(parameter.position, parameter.isReverse);
        }
        else if (command == "setPrintRate")
        {
            // 印刷倍率
            this.setPrintRate(parameter.rate);
        }
        else if (command == "setPrintFlip")
        {
            // 反転印刷
            this.setPrintFlip(parameter.isFlip);
        }
        else if (command == "setPrintBorderVisible")
        {
            // 枠あり印刷
            this.setPrintBorderVisible(parameter.isVisible);
        }
        else if (command == "changePrintVerticalDirection")
        {
            this.changePrintVerticalDirection(parameter.direction, parameter.isReverse);
        }
        else if (command == "changePrintHorizontalDirection")
        {
            this.changePrintHorizontalDirection(parameter.direction, parameter.isReverse);
        }
        else if (command == "setVisibleBorderColorPicker")
        {
            // 枠色ピッカー表示
            this.setVisibleBorderColorPicker(parameter.left, parameter.top);
        }
        else if (command == "closeBorderColorPicker")
        {
            // 枠色ピッカー非表示
            this.onCloseColorPicker();
        }
        else if (command == "changePrintable")
        {
            // 印刷可能切り替え
            this.changePrintable();
        }
        else if (command == "changeZoomScale")
        {
            // ズーム倍率変更
            var isAutoZoomOff =
                parameter.isAutoZoomOff != null ? parameter.isAutoZoomOff : false;
            this.changeZoomScale(parameter.scale, isAutoZoomOff);
        }
        else if (command == "changeAutoZoom")
        {
            // 自動ズーム切り替え
            this.changeAutoZoom(parameter.isAutoZoom);
        }
    }

    private savePDFCommand()
    {
        // 行動履歴の送信
        this.sendSavePDFLog();

        if(this.$store.getters.userConfig.printRaster)
        {
            // ラスターでPDF保存
            this.savePDFAsRaster(this.$store.getters.userConfig.getPrintDpi());
        }
        else
        {
            if(UserAgentHelper.isElectron())
            {
                // ElectronでPDFの生成と保存
                NativeHelper.sendNativeEvent("request_create_and_save_pdf", {});
            }
            else
            {
                // PDF保存
                this.savePDF();
            }
        }
    }

    // 色変更中
    private onChangingColor(color) {
        this.borderColor = color;
    }

    // 色変更完了
    private onChangedColor(color) {
        this.borderColor = color;
    }

    // カラーピッカー閉じる
    private onCloseColorPicker() {
        this.isBorderColorPickerVisible = false;
    }

    // PDF保存
    private savePDF()
    {
        this.createPdfFromPages(false);
    }
    private savePDFAsRaster(dpi : number)
    {
        this.createPdfFromPagesAsRaster(dpi, false);
    }

    // FIXME 分けたい
    // 履歴送信
    private sendSavePDFLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode
        }

        var applicationState = this.$store.getters.applicationState;
        var actionCode = applicationState.flowMode == 0 ? "905" : "915";

        LogHelper.sendLog(actionCode, logValue);
    }

    // 印刷ファイル保存
    private saveDocument()
    {
        if(UserAgentHelper.isElectron())
        {
            // DL版はネイティブで保存する
            NativeHelper.sendNativeEvent("request_save_as_document", {});
            return;
        }

        var comp = () =>
        {
            // 開いた時のファイル名があればそれを使う
            var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
            FileHelper.saveDocumentAsZip(this.currentDocument, fileName);
            this.sendSaveLog();
        };

        var alert = this.$refs.saveAttentionAlert as SaveAttentionAlert;
        if(alert.isAvailable())
        {
            // モーダルを開き、OKを押したときにセーブ
            alert.open(comp);
        }
        else
        {
            comp();
        }
    }

    // FIXME 分けたい
    // 履歴送信
    private sendSaveLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode,
            templateId : this.$store.getters.data.selectedTemplate.id,
            cloud : 0
        }

        LogHelper.sendLog("1000", logValue);
    }

    // 印刷
    private localPrint()
    {
        this.printCore(() => print());
    }
    private serverPrint()
    {
        this.printCore(() => this.createPdfFromPages(true));
    }
    private printAsRaster(dpi : number)
    {
        this.printCore(() => this.createPdfFromPagesAsRaster(dpi, true));
    }
    private printCore(printProcess : () => void)
    {
        // 待機スクリーン
        let standByScreen = this.$refs.standByScreen as StandByScreen;
        // 用紙の向きをチェックする
        if(this.documentRotate == 90 || this.documentRotate == 270)
        {
            // 用紙が横向きの場合はアラートを表示する
            if(!CookieHelper.getItem("printRotationAlert"))
            {
                let alert = this.$refs.printRotationAlert as PrintRotaionAlert;
                alert.open(() =>
                {
                    // アラートを表示し終わったら印刷処理
                    standByScreen.open(printProcess);
                });
            }
            else
            {
                // "今後表示しない"がONなので印刷処理
                standByScreen.open(printProcess);
            }
        }
        else
        {
            // 用紙が縦向きなのでアラートなしで印刷処理
            standByScreen.open(printProcess);
        }
    }

    // 履歴送信
    private sendPrintLog()
    {
        var pageCount = this.printEndPage - this.printStartPage + 1;

        var logValue = {
            page : pageCount,
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode
        }

        var applicationState = this.$store.getters.applicationState;
        var actionCode = applicationState.flowMode == 0 ? "900" : "910";

        LogHelper.sendLog(actionCode, logValue);
    }

    private get shouldPrintFrontSide(): boolean
    {
        return this.shouldPrintBothSides || this.shouldPrintOnlyFrontSide;
    }

    private get shouldPrintBackSide(): boolean
    {
        return this.shouldPrintBothSides || this.shouldPrintOnlyBackSide;
    }

    private get shouldPrintOnlyFrontSide(): boolean
    {
        // TODO とりあえずの実装
        return !this.shouldPrintBackSide;
    }

    private get shouldPrintOnlyBackSide(): boolean
    {
        // TODO とりあえずの実装
        return this.currentDocument.isReverseSurface;
    }

    private get shouldPrintBothSides(): boolean
    {
        return this.userConfig.isPrintDoubleSides;
    }

    private changeSurface(isReverse: boolean)
    {
        // アンドゥ・リドゥの対象外
        this.currentDocument.setSurface(isReverse);
        // 両面印刷オフ
        this.userConfig.isPrintDoubleSides = false;
    }

    private printDoubleSides()
    {
        // 両面印刷オン
        this.userConfig.isPrintDoubleSides = true;
    }

    // ページの移動
    private goPage(page: number)
    {
        // アンドゥ・リドゥの対象外
        if (page < 0 || this.maxPage <= page)
        {
            return;
        }
        this.currentDocument.currentPageIndex = page;
        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();
    }

    // 印刷部数変更
    private setPaperNumber(paperNumber: number)
    {
        this.paperNumber = paperNumber;
    }

    // 開始ページ変更
    private setPrintStartPage(page: number)
    {
        this.printStartPage = page;
    }

    // 終了ページ変更
    private setPrintEndPage(page: number) {
        this.printEndPage = page;
    }

    // 位置調整 : 縦
    private setVerticalPosition(position: number, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printVerticalPositionReverse = position;
        }
        else
        {
            this.userConfig.printVerticalPosition = position;
        }
    }

    // 位置調整 : 横
    private setHorizontalPosition(position: number, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printHorizontalPositionReverse = position;
        }
        else
        {
            this.userConfig.printHorizontalPosition = position;
        }
    }

    // 印刷倍率
    private setPrintRate(rate: number)
    {
        this.userConfig.printRate = rate;
    }

    // 反転印刷
    private setPrintFlip(isFlip: boolean)
    {
        this.userConfig.isPrintFlip = isFlip;
    }

    // 枠あり印刷
    private setPrintBorderVisible(isVisible: boolean)
    {
        this.userConfig.isPrintBorder = isVisible;
    }

    // 印刷位置
    private changePrintVerticalDirection(direction : string, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printVerticalDirectionReverse = direction;
        }
        else
        {
            this.userConfig.printVerticalDirection = direction;
        }
    }
    private changePrintHorizontalDirection(direction : string, isReverse = false)
    {
        if(isReverse)
        {
            this.userConfig.printHorizontalDirectionReverse = direction;
        }
        else
        {
            this.userConfig.printHorizontalDirection = direction;
        }
    }

    // 枠色ピッカー表示
    private setVisibleBorderColorPicker(left, top) {
        // 位置設定
        this.pickerLeft = left;
        this.pickerTop = top;
        // 表示設定
        this.isBorderColorPickerVisible = true;
    }

    // 印刷可能切り替え
    private changePrintable()
    {
        var position = this.currentPage.currentDesignPosition;
        var isPrintable = this.currentPage.getSurface(this.isReverseSurface).isPrintable(position);
        this.currentPage.getSurface(this.isReverseSurface).setPrintable(position, !isPrintable);
    }

    // ズーム倍率のステップ変更
    private changeZoomScaleByStep(up : boolean, isAutoZoomOff : boolean, doCommand : boolean = true) : boolean
    {
        var result = false;
        if(up)
        {
            // 最大ズームサイズチェック
            if(this.zoomScale < Const.CANVAS_ZOOM_MAX)
            {
                if(doCommand)
                {
                    // ズームサイズを+25
                    var newZoomScale = this.zoomScale + 25;
                    if(newZoomScale > Const.CANVAS_ZOOM_MAX) { newZoomScale = Const.CANVAS_ZOOM_MAX; }
                    this.zoomScale = newZoomScale;

                    // オートズーム解除
                    if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
                }
                result = true;
            }
        }
        else
        {
            // 最小ズームサイズチェック
            if(this.zoomScale > Const.CANVAS_ZOOM_MIN)
            {
                if(doCommand)
                {
                    // ズームサイズを-25
                    var newZoomScale = this.zoomScale - 25;
                    if(newZoomScale < Const.CANVAS_ZOOM_MIN) { newZoomScale = Const.CANVAS_ZOOM_MIN; }
                    this.zoomScale = newZoomScale;

                    // オートズーム解除
                    if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
                }
                result = true;
            }
        }

        return result;
    }

    // ズーム倍率変更
    private changeZoomScale(scale, isAutoZoomOff) {
        this.zoomScale = scale;

        // オートズーム解除
        if (isAutoZoomOff && this.isAutoZoom) {
            this.isAutoZoom = false;
        }
    }

    // 自動ズーム切り替え
    private changeAutoZoom(isAutoZoom) {
        this.isAutoZoom = isAutoZoom;
    }

    // ズーム自動切り替え
    private switchAutoZoom(doCommand = true)
    {
        if(doCommand)
        {
            this.isAutoZoom = !this.isAutoZoom;
        }
        return true;
    }

    // レイアウトのページ数
    public get maxPage() : number
    {
        if(this.currentDocument.useInsertion)
        {
            return this.insertionMaxPage;
        }
        else
        {
            return this.currentDocument.pageList.length;
        }
    }

    //** 印刷・pdf周りの処理 **//
    private isUpdatePreview = false;
    private isUpdatePreviewLocal = false;

    private pdfPageIndex = 0;
    private layerIndex = 0;

    private renderPageIndex = 0;
    private renderIsReverse = false;
    private renderDesignPosition = 0;

    // SVG -> PDF
    private outputPageIndex = 0;
    private outputPage : Page | null = null;
    private updateOutputPage()
    {
        this.outputPage = this.getPage(this.outputPageIndex);
    }
    private isOutputReverseSurface = false;
    private arrayBufferArray = new Array();
    private suspendedCreatePdfProcess : ((image : string) => void) | null = null;

    private createPdfFromPages(doPrint = false)
    {
        // レコメンド表示中は行わない
        if(this.loading) { return; }

        this.isUpdatePreview = true;
        this.isUpdatePreviewLocal = false;

        // ポップアップブロック回避のために空きページを作っておく
        //var win = doPrint ? window.open('', '_blank') : null;

        // ローディング開始
        this.isCreatingPrintContent = true;
        this.isRunningPrintLoadingTimer = true;

        // 待ち時間リセット
        this.printWaitNumber = -1;
        // リクエストコードリセット
        this.requestCode = "";

        this.outputPageIndex = this.printStartPage - 1;
        this.isOutputReverseSurface = false;
        this.arrayBufferArray = new Array();
        this.createPdfFromPagesCore(() =>
        {
            var postData = {};
            postData["count"] = this.arrayBufferArray.length;
            var pages = "";
            var filenameArray = new Array();
            for(var i = 0; i < this.arrayBufferArray.length; ++i)
            {
                filenameArray.push("image" + (i + 1));
                pages += "" + (i + 1);
                if(i < this.arrayBufferArray.length - 1)
                {
                    pages += ",";
                }
            }
            postData["pages"] = pages;
            // サイズ指定
            postData["sizeW"] = UnitHelper.convert(this.currentDocument.pageWidth, 'mm', 'px', 96);
            postData["sizeH"] = UnitHelper.convert(this.currentDocument.pageHeight, 'mm', 'px', 96);
            // 作成するのはPDF
            postData["type"] = "1";

            // 完了時処理
            var response = "";
            var isCompletionDone = false;
            var isCompleted = false;
            var completion = () =>
            {
                if(!isCompleted) { return; }
                try
                {
                    var binaryString = atob(response.replace(/\s/g, ''));
                    var len = binaryString.length;
                    var bytes = new Uint8Array(len);
                    for(var i = 0; i < len; ++i)
                    {
                        bytes[i] = binaryString.charCodeAt(i);
                    }
                    var blob = new Blob([bytes], { type: "application/pdf" });
                    var doSave = !doPrint;
                    if(doPrint)
                    {
                        // if(win == null)
                        // {
                        //     doSave = true;
                        // }
                        // else
                        {
                            // pdf印刷
                            var url = FileHelper.createUrl(blob);
                            if(url == null)
                            {
                                doSave = true;
                            }
                            else
                            {
                                // 自動印刷コード
                                if(UserAgentHelper.getBrowser() == "edge")
                                {
                                    // Edgeはblobを開けないので保存
                                    FileHelper.openBlob(blob, "print.pdf");
                                }
                                else
                                {
                                    printJS(url);
                                }
                                // win.location.href = url;
                                // win.addEventListener("beforeunload", function (event)
                                // {
                                //     setTimeout(()=>
                                //     {
                                //         if(win != null) { win.print(); }
                                //     }, 10);
                                // });
                            }
                        }
                    }

                    if(doSave)
                    {
                        // pdf保存
                        FileHelper.saveBlob(blob, "print.pdf");
                    }
                }
                catch(e)
                {
                    DebugHelper.trace(e);
                }
            };

            // PDFを作成する
            this.requestPdfToServer(postData, this.arrayBufferArray, filenameArray, (pdf) =>
            {
                response = pdf;

                // 作成中フラグを下ろす
                this.isCreatingPrintContent = false;
                isCompleted = true;

                // ローディング完了していれば完了処理
                if(!this.loading && !isCompletionDone)
                {
                    isCompletionDone = true;
                    completion();
                }
            }, () =>
            {
                // ローディング終了
                this.isCreatingPrintContent = false;
                isCompleted = false;

                DebugHelper.trace("error");
            });

            // ローディングを指定時間でオフにするタイマー
            setTimeout(() =>
            {
                // 待ちフラグを落とす
                this.isRunningPrintLoadingTimer = false;

                // ローディング完了していれば完了処理
                if(!this.loading && !isCompletionDone)
                {
                    isCompletionDone = true;
                    completion();
                }

            },
            Const.PRINT_LOADING_MIN_MILLISECONDS);
        });
    }

    static readonly BASE64_MARKER = ';base64,';
    private createPdfFromPagesCore(completion : () => void)
    {
        // 出力ページ更新
        this.updateOutputPage();
        this.$nextTick(() =>
        {
            if(this.isPrintable())
            {
                // SVGを取得する
                var preview = this.$refs.preview as PagePreview;
                var svgImage = preview.getSvgImage();
                var base64Idx = svgImage.indexOf(PrintSetting.BASE64_MARKER) + PrintSetting.BASE64_MARKER.length;
                var base64 = svgImage.substring(base64Idx);
                var raw = atob(base64);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for(var i = 0; i < rawLength; ++i)
                {
                    array[i] = raw.charCodeAt(i);
                }

                var buf = array.buffer as ArrayBuffer;
                this.arrayBufferArray.push(buf);
            }

            // 次
            if(this.outputPage != null && this.outputPage.hasReverse && this.isOutputReverseSurface == false)
            {
                // 裏面
                this.isOutputReverseSurface = true;
                this.createPdfFromPagesCore(completion);
            }
            else if(this.outputPageIndex + 1 < this.printEndPage)
            {
                // 次のページ
                this.isOutputReverseSurface = false;
                this.outputPageIndex++;
                this.createPdfFromPagesCore(completion);
            }
            else
            {
                // 終了
                completion();
            }
        });
    }

    // PDFをサーバーへリクエストする処理メイン
    private requestCode = "";
    private requestPdfToServer(postData : { [ key : string ] : string } | null, bufArray : Array<ArrayBuffer>, fileNameArray : Array<string>, completion : (pdf : string) => void, error : () => void)
    {
        // SVG送信
        RequestHelper.postMultiBinary("send_svg", postData, bufArray, fileNameArray, "image/svg+xml", (response1) =>
        {
            try
            {
                // JSON Parse
                var responce1Obj = JSON.parse(response1);
                // コードを取得する
                this.requestCode = responce1Obj.code;

                // ステータス確認する
                var checkPostData = {};
                checkPostData["code"] = this.requestCode;
                this.checkPdfStatusFromServer(checkPostData, () =>
                {
                    // 完了
                    // SVGを取得する
                    RequestHelper.post("get_create_data", checkPostData, (response2) =>
                    {
                        // 取得成功
                        DebugHelper.trace("Succeeded to get pdf.");
                        completion(response2);
                    },() =>
                    {
                        // 取得失敗
                        DebugHelper.trace("Failed to get pdf.");
                        error();
                    });
                },() =>
                {
                    // 失敗
                    error();
                });
            }
            catch(e1)
            {
                // SVG送信に失敗
                DebugHelper.trace("Failed to send svg.");
                error();
            }
        },
        () =>
        {
            // SVG送信に失敗
            DebugHelper.trace("Failed to send svg.");
            error();
        });
    }

    // PDF作成のステータスをサーバーに見に行く処理
    private checkPdfStatusFromServer(postData : { [ key : string ] : string } | null, completion : () => void, error : () => void)
    {
        // 確認を投げる
        RequestHelper.post("get_svg_status", postData, (response) =>
        {
            try
            {
                // JSON Parse
                var responseObj = JSON.parse(response);
                // 待ち人数更新
                this.printWaitNumber = responseObj.waitNum;
                // ステータスを取得する
                var status = responseObj.status;
                if(status == 1 || status == 2)
                {
                    if(status == 1)
                    {
                        // 未処理
                        DebugHelper.trace("get svg status... before processing");
                    }
                    else if(status == 2)
                    {
                        // 処理中
                        DebugHelper.trace("get svg status... under processing");
                    }

                    // ポーリング時間経過後再確認
                    setTimeout(() => this.checkPdfStatusFromServer(postData, completion, error), PrintSetting.PRINT_WAIT_POLLING_TIME);
                }
                else if(status == 3)
                {
                    // 処理終了
                    DebugHelper.trace("get svg status... finished processing");
                    completion();
                }
                else
                {
                    // 処理失敗
                    DebugHelper.trace("get svg status... failed to process : status " + status);
                    error();
                }
            }
            catch(e)
            {
                // ステータス確認失敗
                DebugHelper.trace("Failed to get svg status.");
                error();
            }
        },() =>
        {
            // ステータス確認失敗
            DebugHelper.trace("Failed to get svg status.");
            error();
        });
    }

    // 印刷キャンセル
    private onCancelPrint()
    {
        var postData = {};
        postData["code"] = this.requestCode;
        RequestHelper.post("cancel_convert", postData, (response) =>
        {
            try
            {
                var responseObj = JSON.parse(response);
                var status = responseObj.status;
                if(status == 0)
                {
                    // キャンセル成功
                    this.isCreatingPrintContent = false;
                    this.isRunningPrintLoadingTimer = false;

                    // キャンセル失敗
                    DebugHelper.trace("Succceed to cancel requesting svg to pdf.");
                }
                else
                {
                    // キャンセル失敗
                    DebugHelper.trace("Faild to cancel requesting svg to pdf.");
                }
            }
            catch(e)
            {
                // キャンセル失敗
                DebugHelper.trace("Faild to cancel requesting svg to pdf.");
            }
        },() =>
        {
            // キャンセル失敗
            DebugHelper.trace("Faild to cancel requesting svg to pdf.");
        });
    }

    // ラスターでページのPDFを作成する
    // 原則ローカルで行うが、IEの場合はJpegをローカル生成できないので、そこだけサーバになる
    private createPdfFromPagesAsRaster(dpi : number, doPrint = false)
    {
        // レコメンド表示中は行わない
        if(this.loading) { return; }

        DebugHelper.trace("Raster print dpi: " + dpi);

        this.isUpdatePreview = true;
        this.isUpdatePreviewLocal = true;

        // ローディング開始
        this.isCreatingPrintContent = true;

        this.outputPageIndex = this.printStartPage - 1;
        this.isOutputReverseSurface = false;
        this.arrayBufferArray = new Array();

        // PDFドキュメント作成
        let orientaion = "p";
        let pageWidth = UnitHelper.convert(this.currentDocument.pageWidth, "mm", "pt");
        let pageHeight = UnitHelper.convert(this.currentDocument.pageHeight, "mm", "pt");
        if(this.currentDocument.rotate == 90 || this.currentDocument.rotate == 270)
        {
            // 90, 270度回転の場合は入れ替え
            orientaion = "l";
            let tmp = pageHeight;
            pageHeight = pageWidth;
            pageWidth = tmp;
        }
        let pdf = new jsPDF(orientaion, "mm", [pageWidth, pageHeight]);

        this.createPdfFromPagesAsRasterCore(pdf, true, dpi, () =>
        {
            if(UserAgentHelper.isElectron())
            {
                // dataurlを保持する
                // PrintJSは内部でiframeを生成するが、electronではダウンロードになってしまうので使えない。
                this.$store.getters.userConfig.exportedPDF = pdf.output('dataurlstring');
                // Electronに処理のリクエスト
                let req = doPrint ? "request_print_pdf" : "request_save_pdf";
                NativeHelper.sendNativeEvent(req, { printResolution : "" + dpi });
                
                // this.isCreatingPrintContent = false; はelectronからのexecCommandを待つ。
            }
            else
            {
                if(doPrint && UserAgentHelper.getBrowser() != "edge")
                {
                    // プリント処理
                    pdf.autoPrint();
                    printJS(pdf.output('bloburl'));
                }
                else
                {
                    // 保存処理
                    pdf.save("print.pdf");
                }
                this.isCreatingPrintContent = false;
            }

            this.isUpdatePreview = false;
        });
    }

    private createPdfFromPagesAsRasterCore(pdf, isFirstPage : boolean, dpi : number, completion : () => void)
    {
        // 出力ページ更新
        this.updateOutputPage();
        this.$nextTick(() =>
        {
            if(this.isPrintable())
            {
                // SVGを取得する
                let preview = this.$refs.preview as PagePreview;
                let width = UnitHelper.convert(this.currentDocument.pageWidth, "mm", "px", dpi);
                let height = UnitHelper.convert(this.currentDocument.pageHeight, "mm", "px", dpi);
                if(UserAgentHelper.isElectron())
                {
                    // Electron の場合、canvasを利用したjpegの作成をすると、フォントが適用されない。
                    // よって、Electron上でキャプチャ処理を行う。
                    const svgElement = preview.getSvgElement();
                    const xml = (new XMLSerializer()).serializeToString(svgElement);
                    const blob = new Blob([xml], {type: 'image/svg+xml'});
                    const url = `${URL.createObjectURL(blob)}?op=page&width=${width}&height=${height}&type=jpg`;
                    // この続きの処理をexecCommandで呼び出せるようにしておく
                    this.suspendedCreatePdfProcess = (captureImage : string) =>
                    {
                        if(!isFirstPage) pdf.addPage();
                        isFirstPage = false;
                        pdf.addImage(captureImage, "JPEG", 0, 0, this.currentDocument.pageWidth, this.currentDocument.pageHeight);
                        // 次へ
                        this.afterCreatePdfFromPagesAsRasterCore(pdf, isFirstPage, dpi, completion);
                    };
                    window.open(url);
                }
                else
                {
                    let svgImage = preview.getSvgImage();
                    // SVG -> JPEG
                    ImageHelper.convertSVGImageToJpeg(svgImage, width, height, 0, (jpg) =>
                    {
                        if(!isFirstPage) pdf.addPage();
                        isFirstPage = false;
                        pdf.addImage(jpg, "JPEG", 0, 0, this.currentDocument.pageWidth, this.currentDocument.pageHeight);
                        // 次へ
                        this.afterCreatePdfFromPagesAsRasterCore(pdf, isFirstPage, dpi, completion);
                    });
                }
            }
            else
            {
                // スキップして次へ
                this.afterCreatePdfFromPagesAsRasterCore(pdf, isFirstPage, dpi, completion);
            }
        });
    }
    private afterCreatePdfFromPagesAsRasterCore(pdf, isFirstPage : boolean, dpi : number, completion : () => void)
    {
        // 次
        if(this.outputPage != null && this.outputPage.hasReverse && this.isOutputReverseSurface == false)
        {
            // 裏面
            this.isOutputReverseSurface = true;
            this.createPdfFromPagesAsRasterCore(pdf, isFirstPage, dpi, completion);
        }
        else if(this.outputPageIndex + 1 < this.printEndPage)
        {
            // 次のページ
            this.isOutputReverseSurface = false;
            this.outputPageIndex++;
            this.createPdfFromPagesAsRasterCore(pdf, isFirstPage, dpi, completion);
        }
        else
        {
            // 終了
            completion();
        }
    }

    private isPrintable()
    {
        var result = false;
        if(this.isOutputReverseSurface)
        {
            // 裏面
            if(this.userConfig.isPrintDoubleSides || this.isReverseSurface)
            {
                // 両面印刷 or 裏面
                result = true;
            }
        }
        else
        {
            // 表面
            if(this.userConfig.isPrintDoubleSides || !this.isReverseSurface)
            {
                // 両面印刷　or 表面
                result = true;
            }
        }

        return result;
    }

    //選択中用紙
    get selectedPaper(){
        return this.$store.getters.data.selectedPaper
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }


    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("printSettingTutorial") != true;
    }

    // 表の印刷位置を調整するtransform引数
    private get translateFront(): string {
        const x = this.userConfig.offsetFrontX();
        const y = this.userConfig.offsetFrontY();
        return `translate(${mm2px(x, 72)} ${mm2px(y, 72)})`;
    }

    // 裏の印刷位置を調整するtransform引数
    private get translateBack(): string {
        const x = this.userConfig.offsetBackX();
        const y = this.userConfig.offsetBackY();
        return `translate(${mm2px(x, 72)} ${mm2px(y, 72)})`;
    }

    //*** DL版のメニュー実装 ***/

    // 新規ドキュメント
    private isSaveModalVisible = false;
    private saveModalCompletion = () => {};
    private createNewDocument(doCommand = true)
    {
        if(doCommand)
        {
            let completion = () =>
            {
                // フローを通常にする
                this.$store.getters.applicationState.flowMode == 0;

                // 用紙選択に遷移
                this.$router.push("/SelectPage");
            }

            // TODO 本来は編集フラグを見ること。
            if(true)
            {
                // 保存させるか選択するモーダルを表示する
                this.isSaveModalVisible = true;
                // 完了時の処理
                this.saveModalCompletion = () =>
                {
                    completion();
                };
            }
            else
            {
                completion();
            }
        }

        return true;
    }

    // 保存モーダルのコールバック
    private saveModalCallback(button : string)
    {
        if(button == "save")
        {
            this.saveDocument();
        }

        // 完了処理
        this.saveModalCompletion();
    }

}

